import { TABLET_API_ORIGIN } from '@/global/env';
import { errorHandler } from '@/lib/ErrorHandler';
import { RestClientInterface } from '@/lib/restClient';
import {
  MosPosOrderActionResponse,
  MosPosOrderDetailResponse,
  MosPosOrderListParams,
  MosPosOrderListResponse,
  MosPosStoreListResponse,
} from '@/services/MosPosOrder/type';

export class MosPosOrderService {
  constructor(private readonly restClient: RestClientInterface) {}

  public async list(
    params: MosPosOrderListParams
  ): Promise<MosPosOrderListResponse> {
    const query = new URLSearchParams();
    if (params.deliveryServiceId !== undefined) {
      query.append('delivery_service_id', String(params.deliveryServiceId));
    }
    params.authStoreIds?.forEach((authStoreId) => {
      query.append('auth_store_ids', String(authStoreId));
    });
    query.append('order_date_start', params.orderDateStart);
    query.append('order_date_end', params.orderDateEnd);
    query.append('page', String(params.page));
    query.append('page_size', String(params.pageSize));

    return await this.restClient
      .get<MosPosOrderListResponse>(
        `${TABLET_API_ORIGIN}/dashboard-api/mos-pos-orders?${query.toString()}` as const
      )
      .catch((error: Error) => errorHandler({ error }));
  }

  // NOTE 候補の取得失敗で一覧画面から遷移させないよう errorHandler を通さない
  public async listStores(): Promise<MosPosStoreListResponse> {
    return await this.restClient.get<MosPosStoreListResponse>(
      `${TABLET_API_ORIGIN}/dashboard-api/mos-pos-stores` as const
    );
  }

  public async detail(orderId: string): Promise<MosPosOrderDetailResponse> {
    return await this.restClient.get<MosPosOrderDetailResponse>(
      `${TABLET_API_ORIGIN}/dashboard-api/mos-pos-orders/${orderId}` as const
    );
  }

  /**
   * NOTE 再送信 / 取消は errorHandler を通さない。
   *      409 (ステータス競合) とそれ以外の失敗を呼び出し側で
   *      区別してトーストを出し分ける必要があるため。
   */
  public async resend(orderId: string): Promise<MosPosOrderActionResponse> {
    return await this.restClient.post<undefined, MosPosOrderActionResponse>(
      `${TABLET_API_ORIGIN}/dashboard-api/mos-pos-orders/${orderId}/resend` as const
    );
  }

  public async cancel(orderId: string): Promise<MosPosOrderActionResponse> {
    return await this.restClient.post<undefined, MosPosOrderActionResponse>(
      `${TABLET_API_ORIGIN}/dashboard-api/mos-pos-orders/${orderId}/cancel` as const
    );
  }
}
